import { createSelector } from '@reduxjs/toolkit';
import { selectTravelTimeFilter } from './selectTravelTimeFilter';
import { selectTravelTypeFilter } from './selectTravelTypeFilter';

export const selectUndergroundTimeFilter = createSelector(
  [selectTravelTimeFilter, selectTravelTypeFilter],
  (travelTime, travelType) => ({
    label: 'До метро',
    traveTimeFilter: travelTime,
    travelTypeFilter: travelType,
  }),
);
